import React from "react";
import { getUser } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";

function WebsiteHomePage() {
  const user = getUser(ROLE.USER);

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour >= 5 && hour < 12) return "Good Morning";
    if (hour >= 12 && hour < 17) return "Good Afternoon";
    if (hour >= 17 && hour < 21) return "Good Evening";
    return "Good Night";
  };

  return (
    <main className="p-8 bg-zinc-50 min-h-screen">
      <div className="container mx-auto">
        <div className="mb-8 p-6 bg-white rounded-2xl shadow-sm border border-zinc-100">
          <h2 className="text-3xl font-bold text-zinc-900 mb-2">
            {getGreeting()}, {user?.name || "Guest"}!
          </h2>
          <p className="text-zinc-500">Welcome back to ThelaLive. Hope you're having a great {getGreeting().split(' ')[1]?.toLowerCase() || 'day'}!</p>
        </div>

        <div className="bg-blue-600 text-white p-8 rounded-2xl shadow-lg mb-8">
          <h1 className="text-4xl font-black mb-4">Discover Amazing Products</h1>
          <p className="text-blue-100 text-lg mb-6 max-w-2xl">
            Join live streams and shop directly from your favorite sellers in real-time.
          </p>
          <button className="bg-white text-blue-600 hover:bg-zinc-100 font-bold px-8 py-3 rounded-xl transition-all shadow-md hover:shadow-lg">
            Start Shopping
          </button>
        </div>
      </div>
    </main>
  );
}

export default WebsiteHomePage;
